export const isBrowser = () => typeof window !== "undefined";

export const isDOMAvailable = () => isBrowser() && !!window.document && !!window.document.createElement;
